import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "triggers" }
const _hoisted_2 = { class: "triggers-contents" }
const _hoisted_3 = { class: "triggers-summary" }
const _hoisted_4 = {
  key: 0,
  class: "proactive-trigger-message"
}
const _hoisted_5 = { class: "flow-trigger-box" }
const _hoisted_6 = { class: "trigger-option-icon" }
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = {
  key: 0,
  class: "custom-icon"
}
const _hoisted_9 = ["xlink:href"]
const _hoisted_10 = { class: "trigger-option-description" }
const _hoisted_11 = {
  key: 0,
  class: "edit-icon"
}
const _hoisted_12 = {
  key: 1,
  class: "none-option-description"
}

import IslandBadge from './IslandBadge.vue';
import { AvailableTriggers, FlowViewModel, TriggerType } from '@/features/bots/models/designer';
import { ConditionGroupViewModel } from '@/shared/components/conditions/models/conditionGroupViewModel';
import EditIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import EditIntentModal from '@/features/bots/components/designer/EditIntentModal.vue';
import { ParentViewModel } from '@/features/bots/models/parentViewModel';
import TransitionPicker from '@/features/bots/components/designer/TransitionPicker.vue';
import { TransitionType } from '@/features/bots/models/designer/transitionType';
import { TransitionViewModel } from '@/features/bots/models/designer/transitionViewModel';
import { TriggerItem } from '@/features/bots/models/designer/triggerType';
import { ConditionGroup } from '@/shared/components/conditions/models/conditionGroup';
import { UsageLimitType } from '@/features/settings/models/usageLimitType';
import AlertOutline from 'vue-material-design-icons/AlertOutline.vue';
import { computed, PropType, ref } from 'vue';
import { useStore } from 'vuex';
import { TriggerConditionAttributeType } from '@/features/bots/components/designer/Conditions/useTriggerConditions';


export default /*@__PURE__*/_defineComponent({
  __name: 'Triggers',
  props: {
  conditions: {
    type: Object as PropType<ConditionGroupViewModel>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const store = useStore();
const parentFlows = computed(() => store.getters.parentFlows);
const parentAnswers = computed(() => store.getters.parentAnswers);
const currentFlow = computed(() => store.getters.currentFlow);
const isCurrentFlowTriggerable = computed(() => store.getters.isCurrentFlowTriggerable);
const getIntentName = computed(
  () =>
    (intentId: string): string =>
      store.getters.getIntentName(intentId),
);
const workspaceUsageLimit = computed(
  () =>
    (feature: UsageLimitType): number =>
      store.getters.workspaceUsageLimit(feature),
);
const proactiveTriggerLimit = computed(() => workspaceUsageLimit.value(UsageLimitType.ProactiveTriggers));

const intentToEdit = ref('');
const showModal = ref(false);

function getFlowTransition(flow: ParentViewModel) {
  return {
    payload: flow.id,
    type: TransitionType.Flow,
  } as TransitionViewModel;
}

function getAnswerTransition(answer: ParentViewModel) {
  return {
    payload: answer.id,
    type: TransitionType.Answer,
  } as TransitionViewModel;
}

function getSelectedTriggerDescription(type: string) {
  const selected = AvailableTriggers.get(type);
  if (selected) {
    if (selected.type === TriggerType.MessageReceived && props.conditions) {
      return getDescriptionForMessageReceived(selected);
    }
    return selected.description;
  }
}

function getIconName(iconKey: string) {
  return AvailableTriggers.get(iconKey).icon;
}

function editIntent(trigger: string) {
  const intent = getIntentCondition(trigger);
  if (intent) {
    intentToEdit.value = intent.value;
    showModal.value = true;
  }
}

function isValidIntentSelected(trigger: string) {
  const intentCondition = getIntentCondition(trigger);
  return !!intentCondition && !!getIntentName.value(intentCondition.value);
}

function shouldDisplayProactiveTriggerMessage() {
  return (
    proactiveTriggerLimit.value === 0 &&
    currentFlow.value.triggers.some((trigger: string) => {
      return trigger === TriggerType.WidgetLoaded;
    })
  );
}

function getIntentCondition(trigger: string) {
  const selected = AvailableTriggers.get(trigger);
  if (selected) {
    if (selected.type === TriggerType.MessageReceived && props.conditions) {
      return ConditionGroup.find(
        props.conditions,
        (c) => c.attribute === TriggerConditionAttributeType.MessageIntent && c.value.length > 0,
      );
    }
  }
}

function getDescriptionForMessageReceived(selected: TriggerItem) {
  let output = '';
  const conditions = ConditionGroup.findAll(
    props.conditions,
    (c) =>
      (c.attribute === TriggerConditionAttributeType.MessageText ||
        c.attribute === TriggerConditionAttributeType.MessageIntent) &&
      c.value.length > 0,
  );
  for (const condition of conditions) {
    if (condition.type === 'intent') {
      output += ` ${getIntentName.value(condition.value) || condition.value}`;
    } else {
      output += ` ${condition.value}`;
    }
  }
  return output ? output : selected.description;
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(IslandBadge, {
      type: "trigger",
      draggable: false
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (shouldDisplayProactiveTriggerMessage())
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(AlertOutline, { class: "icon-1-5x" }),
              _cache[3] || (_cache[3] = _createElementVNode("p", null, "This flow will not be triggered on page load because the workspace has a proactive trigger limit of 0", -1))
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentFlow.value.triggers, (trigger, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "transition",
            key: index
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  (getIconName(trigger).startsWith('#'))
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_8, [
                        _createElementVNode("use", {
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          "xlink:href": getIconName(trigger)
                        }, null, 8, _hoisted_9)
                      ]))
                    : _createCommentVNode("", true),
                  (!getIconName(trigger).startsWith('#'))
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 1,
                        class: "fa-icons",
                        icon: ['far', getIconName(trigger)]
                      }, null, 8, ["icon"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", null, _toDisplayString(getSelectedTriggerDescription(trigger)), 1)
              ]),
              (isValidIntentSelected(trigger))
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(EditIcon, {
                      class: "icon-1-2x",
                      onClick: _withModifiers(($event: any) => (editIntent(trigger)), ["stop"])
                    }, null, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128)),
        (!isCurrentFlowTriggerable.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, "None"))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parentFlows.value, (linkedFlow) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "transition",
            key: linkedFlow.id
          }, [
            _createVNode(TransitionPicker, {
              transition: getFlowTransition(linkedFlow),
              fixed: true
            }, null, 8, ["transition"])
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parentAnswers.value, (parentAnswer) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "transition",
            key: parentAnswer.id
          }, [
            _createVNode(TransitionPicker, {
              transition: getAnswerTransition(parentAnswer),
              fixed: true
            }, null, 8, ["transition"])
          ]))
        }), 128))
      ])
    ]),
    (showModal.value)
      ? (_openBlock(), _createBlock(EditIntentModal, {
          key: 0,
          "intent-id": intentToEdit.value,
          onClosed: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = false)),
          onCompleted: _cache[1] || (_cache[1] = ($event: any) => (showModal.value = false)),
          onFailedToLoad: _cache[2] || (_cache[2] = ($event: any) => (showModal.value = false))
        }, null, 8, ["intent-id"]))
      : _createCommentVNode("", true)
  ]))
}
}

})